import { nameToRgba } from "@/public/utils/tool.js";

export default {
    state: {
        /** listdata*/
        orient: "", // 表格方向
        currentType: "", // 当前选中的是什么类型的图表 string
        chartType: "", // 当前选中的是什么类型 string
        index: 0, // 当前选中的系列 number
        typeSeries: [], // 系列数组 Array: [object]
        chartData: [["", "", ""]], // 表格数据 Array: [[string], [], []]
        chartDataColor: [], // 表格数据颜色 Array: [#ffffff, #ffffff]
        changeColor: "", // 表格数据修改的颜色 string #ffffff
        // 用于右侧编辑数据面板和浮动样式面板同步
        colorIndex: 0, // 点击的色块index
        legend: "topCenter", // legend  string: [hidden, topCenter, topRight, middleRight, bottomCenter]
        seriesGap: 0, // 序列间距 number: 0-1
        categoryGap: 0, // 分类间距 number: 0-1
        currentSeries: "all", // 当前选中的系列 string: [all, name1, name2...]
        seriesShapeType: "bar", // 当前系列类型 string: [bar, line]
        seriesLabelPosition: "top", // 数据标签位置 string: [hidden, top. inside]
        stackName: false, // 堆叠系列名 boolean
        serieslist: [], // 系列列表 Array: [string]
        lineAreaFill: "fill", // 线图填充 string: [fill, no-fill]
        lineStepType: "", // 线图阶梯图 string: [start, end, none]

        symbolType: "", // 拐点形状 string: ['emptyCircle' ，'circle', 'rect', 'roundRect', 'triangle', 'diamond', 'pin', 'arrow', 'none']
        symbolSize: 0, // 拐点大小 number

        setBubbleMode: "", // 切换气泡图 string: [scatter, bubble]
        BubbleMaxSize: "", // 气泡范围  { minValue：最小值 ，maxValue：最大值 ，bubleMinSize：气泡最小值，bubleMaxSize：气泡最大值  }
        BubbleMinSize: "", // 气泡范围
        maxValue: "", // 气泡范围
        minValue: "", // 气泡范围
        BubbleMinLimit: 0, // 气泡限制
        BubbleMaxLimit: 0, // 气泡限制

        insideRadiusRatio: 0, // 内半径之比 number
        pieList: [], // 饼图列表 Array[object]
        colorListIndex: 0, // 饼图列表索引 number
        pieRotate: 0, // 饼图旋转角度 number

        gaugeRangeMaxsize: 0, // 仪表图最大范围 number
        gaugeRangeMinsize: 0, // 仪表图最小范围 number
        gaugeRangeArr: [], // 仪表图颜色及范围 Array[Array ]
        gaugeRangeIndex: 0, // 仪表图索引

        radarMaxIndicatorVal: 0, // 雷达图指示器的最大值
        typeList: [],
        symbolTypeList: [], // line 拐点类型
        //serieslist 名称 chartDataColor 颜色  typeList 类型
        coordinateRadio: 0,
        coordinateType: "",
        coordinateData: [],
        xAxisAttr: {},
        yAxisAttr: {},
        coordinateName: "",
        coordinatePosition: "",
        coordinateMax: 0,
        coordinateMin: 0,
        coordinateSegment: 0,
        coordinateShape: "",
        coordinateShowSplit: false,
        GridxAxisLabelPosition: 1, //类目轴中在 boundaryGap 为 true 的时候有效，可以保证刻度线和标签对齐
        yAxisLabelPosition: 1, // y轴刻度标签位置
        xAxisLabelPosition: 1, // x轴位置 适用于条形图
        coordinateShowScale: false,
        coordinateAxisShow: true, // 坐标轴
        xLabelOrientationType: 0, //  坐标轴刻度标签旋转方向
        coordinateAxisLabelRotate: 0, //  坐标轴刻度标签旋转角度
        dataFormat: 0,
        dataFormatAccuracy: 0,
        dataFormatPercent: false,
        dataFormatPreUnit: "",
        axisPrefixSuffix: "",
        valuePrefixSuffix: "",
        dataFormatSufUnit: "",
        hasPercent: false,
        isPercent: false,
        minLimit: 0,
        maxLimit: 0,
        percentLabel: "",
        roseType: "none",
        colorMappingType: 0,
        colorMappingMax: 0,
        colorMappingMin: 0,
        colorMappingWidth: 0,
        colorMappingHeight: 0,
        colorMappingRadio: "H",
        colorMappingPosition: 0,
        visualMap: "",
        mapBackground: "",
        visualMapHeight: 0,
        visualMapHightColor: "",
        visualMapHightText: "",
        visualMapLowColor: "",
        visualMapLowText: "",
        visualMapMax: 0,
        visualMapMaxLimit: 0,
        visualMapMin: 0,
        visualMapMinLimit: 0,
        visualMapOrient: "",
        visualMapWidth: 0,
        labelVisible: false,
        colorMappingArr: [
            {
                number: 0,
                color: "#fff",
            },
        ],
        funnelGap: 0,
        funnelMax: 0,
        funnelMaxLimit: 0,
        funnelMaxSize: 0,
        funnelMin: 0,
        funnelMinLimit: 0,
        funnelMinSize: 0,
        funnelSort: "",
        funnelPercent: false,
        scale_x: false,
        scale_y: false,
        labelType: 2,
        expandList: ["style", "setting", "series", "coordinate", "dataFormat", "radarCoordinate", "colorMapping", "mapStyle", "mapRegion"],
        smoothLine: false,
        coordinateColor: "",
        mapColorType: "",
        mapColorData: "",
        mapLineColor: "",
        mapRegionData: [],
        activeSeriesColor: "",
        activeSeriesColorAlpha: 1,
        activeBgColor: "",
    },
    actions: {
        clickSeries(state, num) {
            // 结算
            state.state.index = num;
            if (state.state.chartType == "pie") {
                state.state.colorListIndex = num - 1;
            }
            state.state.currentSeries = state.state.serieslist[num - 1];
            let data = window["_view"].getChartData();
            data.isInit = true;
            state.commit("initEChart", data);
        },
    },
    mutations: {
        setEChartState(state, obj) {
            state[obj.type] = obj.data;
            if (obj.type === "activeSeriesColor") {
                let color = nameToRgba(obj.data);
                let newAlpha = color[color.length - 1];
                state.activeSeriesColorAlpha = newAlpha;
            }
        },
        setxAxisAttr(state, obj) {
            state["xAxisAttr"][obj.type] = obj.data;
        },
        setyAxisAttr(state, obj) {
            state["yAxisAttr"][obj.type] = obj.data;
        },
        indexEChart(state) {
            if (state.currentSeries == "all") {
                state.index = 0;
                return;
            }
            for (let i = 0; i < state.serieslist.length; i++) {
                if (state.currentSeries == state.serieslist[i]) {
                    state.index = i + 1;
                    return;
                }
            }
        },
        initEChart(state, object) {
            state.chartDataColor = [];
            state.serieslist = [];
            state.typeList = [];
            this.commit("indexEChart");
            if (!object?.seriesOpt) {
                state.chartDataColor = [];
                return;
            }
            if (object.seriesOpt[state.index] == undefined) {
                // 切换图表的时候，恢复选择序列到全选
                state.currentSeries = "all";
                state.index = 0;
            }
            state.setBubbleMode = "";
            state.orient = object.CoordSysOpt.categoryOrient || "horizontal";
            state.currentType = object.seriesOpt[0].type;
            state.chartType = state.index !== 0 ? object.seriesOpt[state.index].type : object.seriesOpt[0].type;
            state.typeSeries = object.seriesOpt || 0;
            if (object.dataSheet && object.dataSheet[0]) state.chartData = object.dataSheet[0] || [["", "", "", "", "", ""]];
            state.legend = object.staticOpt.legendStatus || "topCenter";
            state.seriesGap = object.seriesOpt[0].barGap * 100 || 0;
            state.categoryGap = object.seriesOpt[0].categoryGap * 100 || 0;
            state.seriesShapeType = state.index !== 0 ? object.seriesOpt[state.index].type : object.seriesOpt[0].type;
            state.seriesLabelPosition = object.seriesOpt[state.index].labelVisible ? object.seriesOpt[state.index].labelPosition : "hidden";
            state.serieslist = object.seriesNames || [];
            state.stackName = "";
            state.visualMap = object.visualMap;
            state.labelVisible = object.seriesOpt[state.index].labelVisible;
            state.mapBackground = object.seriesOpt[0].mapAreaColor;
            state.mapLineColor = object.seriesOpt[0].mapLineColor;
            state.mapRegionData = object.seriesOpt[0].mapRegionData;
            if (object.visualMap) {
                state.visualMapHeight = object.visualMap.height;
                state.visualMapHightColor = object.visualMap.hightColor;
                state.visualMapHightText = object.visualMap.hightText;
                state.visualMapLowColor = object.visualMap.lowColor;
                state.visualMapLowText = object.visualMap.lowText;
                state.visualMapMax = object.visualMap.max;
                state.visualMapMaxLimit = object.visualMap.maxLimit;
                state.visualMapMin = object.visualMap.min;
                state.visualMapMinLimit = object.visualMap.minLimit;
                state.visualMapOrient = object.visualMap.status;
                state.visualMapWidth = object.visualMap.width;
                state.mapColorType = object.visualMap.type;
                if (object.visualMap.pieces) {
                    let pieces = object.visualMap.pieces;
                    let arr = [];
                    for (let i = 0; i < pieces.length; i++) {
                        arr.push([pieces[i].max, pieces[i].color]);
                    }
                    state.mapColorData = arr;
                } else {
                    state.mapColorData = [];
                }
            }

            if (object.seriesOpt.length == 1) {
                state.typeList = [object.seriesOpt[0].type];
            } else {
                state.typeList = object.seriesOpt.map((v, k) => {
                    if (k == 0) {
                        return "";
                    } else {
                        return v.type;
                    }
                });
            }

            /**bar */
            if (state.seriesShapeType == "bar") {
                state.barColor =
                    state.index !== 0
                        ? object.seriesOpt[state.index].barStrokeColor
                        : object.seriesOpt[0].barStrokeColor == undefined
                          ? ""
                          : object.seriesOpt[0].barStrokeColor;
                state.stackName = object.seriesOpt[state.index].stackName == "stack_0";
                if (object.seriesOpt.length == 1) {
                    state.chartDataColor = ["", object.seriesOpt[0].barStrokeColor];
                } else {
                    state.chartDataColor = object.seriesOpt.map((v, k) => {
                        if (k == 0) {
                            return "";
                        } else {
                            return v.barStrokeColor;
                        }
                    });
                }
            }
            /**line */
            if (state.seriesShapeType == "line") {
                state.smoothLine = object.seriesOpt[0].smooth;
                state.lineColor =
                    state.index !== 0
                        ? object.seriesOpt[state.index].lineStrokeColor
                        : object.seriesOpt[0].lineStrokeColor == undefined
                          ? ""
                          : object.seriesOpt[0].lineStrokeColor;
                (state.index !== 0 && ((state.lineAreaFill = object.seriesOpt[state.index].isAreaFilled ? "fill" : "no-fill"), true)) ||
                    (state.lineAreaFill = object.seriesOpt[0].isAreaFilled ? "fill" : "no-fill");
                state.lineAreaFilledColor =
                    state.index !== 0
                        ? object.seriesOpt[state.index].AreaFilledColor
                        : object.seriesOpt[0].AreaFilledColor == undefined
                          ? ""
                          : object.seriesOpt[0].AreaFilledColor;
                state.lineStepType = state.index !== 0 ? object.seriesOpt[state.index].stepType : object.seriesOpt[0].stepType;

                state.symbolType =
                    state.index !== 0
                        ? object.seriesOpt[state.index].symbolType
                        : object.seriesOpt[0].symbolType == undefined
                          ? "none"
                          : object.seriesOpt[0].symbolType;
                state.symbolSize =
                    state.index !== 0
                        ? object.seriesOpt[state.index].symbolSize
                        : object.seriesOpt[0].symbolSize == undefined
                          ? 0
                          : object.seriesOpt[0].symbolSize;
                state.symbolColor =
                    state.index !== 0
                        ? object.seriesOpt[state.index].symbolColor
                        : object.seriesOpt[0].symbolColor == undefined
                          ? ""
                          : object.seriesOpt[0].symbolColor;

                if (object.seriesOpt.length == 1) {
                    state.chartDataColor = ["", object.seriesOpt[0].lineStrokeColor];
                    state.symbolTypeList = ["", object.seriesOpt[0].symbolType == undefined ? "none" : object.seriesOpt[0].symbolType];
                } else {
                    state.chartDataColor = object.seriesOpt.map((v, k) => {
                        if (k == 0) {
                            return "";
                        } else {
                            return v.lineStrokeColor;
                        }
                    });
                    state.symbolTypeList = object.seriesOpt.map((v, k) => {
                        if (k == 0) {
                            return "";
                        } else {
                            return v.symbolType;
                        }
                    });
                }
            }
            /**scatter */
            if (state.seriesShapeType == "scatter") {
                state.setBubbleMode = object.seriesOpt[0].isBubble ? "bubble" : "scatter";

                (state.index !== 0 &&
                    ((state.symbolColor =
                        Object.prototype.toString.call(object.seriesOpt[state.index].symbolColor) === "[Object Object]"
                            ? ""
                            : object.seriesOpt[state.index].symbolColor),
                    true)) ||
                    (state.symbolColor =
                        Object.prototype.toString.call(object.seriesOpt[0].symbolColor) === "[Object Object]" ? "" : object.seriesOpt[0].symbolColor);
                state.symbolColor = state.symbolColor == undefined ? "" : state.symbolColor;

                state.symbolType = state.index !== 0 ? object.seriesOpt[state.index].symbolType : object.seriesOpt[0].symbolType;
                state.symbolSize =
                    state.index !== 0
                        ? object.seriesOpt[state.index].symbolSize
                        : object.seriesOpt[0].symbolSize == undefined
                          ? 0
                          : object.seriesOpt[0].symbolSize;
                if (state.setBubbleMode == "bubble") {
                    /**bubble */
                    state.BubbleMaxSize = object.seriesOpt[0].BubbleRange.BubbleMaxSize;
                    state.BubbleMinSize = object.seriesOpt[0].BubbleRange.BubbleMinSize;
                    state.maxValue = object.seriesOpt[0].BubbleRange.maxValue;
                    state.minValue = object.seriesOpt[0].BubbleRange.minValue;
                    state.BubbleMinLimit = object.seriesOpt[0].valueRange[0];
                    state.BubbleMaxLimit = object.seriesOpt[0].valueRange[1];
                }

                if (object.seriesOpt.length == 1) {
                    state.chartDataColor = ["", object.seriesOpt[0].symbolColor];
                    state.symbolTypeList = [object.seriesOpt[0].symbolType == undefined ? "none" : object.seriesOpt[0].symbolType];
                } else {
                    state.chartDataColor = object.seriesOpt.map((v, k) => {
                        if (k == 0) {
                            return "";
                        } else {
                            return v.symbolColor;
                        }
                    });
                    state.symbolTypeList = object.seriesOpt.map((v, k) => {
                        if (k == 0) {
                            return "";
                        } else {
                            return v.symbolType;
                        }
                    });
                }
            }
            /**pie */
            if (state.seriesShapeType == "pie") {
                state.insideRadiusRatio = object.seriesOpt[0].insideRadiusRatio * 100;
                let arr = [];
                for (let i = 0, len = object.seriesOpt[0].sectorNames.length; i < len; i++) {
                    let obj = {
                        name: object.seriesOpt[0].sectorNames[i],
                        color: object.seriesOpt[0].sectorColors[i] == undefined ? "" : object.seriesOpt[0].sectorColors[i],
                        offset: object.seriesOpt[0].hasOffset[i],
                    };
                    arr.push(obj);
                }
                state.pieList = arr;
                state.pieRotate = object.seriesOpt[0].startAngle;
                state.chartDataColor = object.seriesOpt[0].sectorColors;
                state.percentLabel = object.seriesOpt[0].percentLabel;
                state.roseType = object.seriesOpt[0].roseType;
                state.labelType = object.dataFormat.seriesLabelType;
            }
            /**gaugeRange */
            if (state.seriesShapeType == "gauge") {
                state.gaugeRangeMinsize = object.seriesOpt[0].gaugeRange.min;
                state.gaugeRangeMaxsize = object.seriesOpt[0].gaugeRange.max;
                state.gaugeRangeArr = object.seriesOpt[0].gaugeSector;
            }
            /**radar */
            if (state.seriesShapeType == "radar") {
                state.lineColor =
                    state.index !== 0
                        ? object.seriesOpt[state.index].lineStrokeColor
                        : object.seriesOpt[0].lineStrokeColor == undefined
                          ? ""
                          : object.seriesOpt[0].lineStrokeColor;
                (state.index !== 0 && ((state.lineAreaFill = object.seriesOpt[state.index].isAreaFilled ? "fill" : "no-fill"), true)) ||
                    (state.lineAreaFill = object.seriesOpt[0].isAreaFilled ? "fill" : "no-fill");
                state.lineAreaFilledColor =
                    state.index !== 0
                        ? object.seriesOpt[state.index].AreaFilledColor
                        : object.seriesOpt[0].AreaFilledColor == undefined
                          ? ""
                          : object.seriesOpt[0].AreaFilledColor;
                state.lineStepType = state.index !== 0 ? object.seriesOpt[state.index].stepType : object.seriesOpt[0].stepType;

                state.symbolColor =
                    state.index !== 0
                        ? object.seriesOpt[state.index].symbolColor
                        : object.seriesOpt[0].symbolColor == undefined
                          ? ""
                          : object.seriesOpt[0].symbolColor;
                state.symbolType = state.index !== 0 ? object.seriesOpt[state.index].symbolType : object.seriesOpt[0].symbolType;
                state.symbolSize =
                    state.index !== 0
                        ? object.seriesOpt[state.index].symbolSize
                        : object.seriesOpt[0].symbolSize == undefined
                          ? 0
                          : object.seriesOpt[0].symbolSize;

                if (object.seriesOpt.length == 1) {
                    state.chartDataColor = ["", object.seriesOpt[0].lineStrokeColor];
                    state.symbolTypeList = [object.seriesOpt[0].symbolType == undefined ? "none" : object.seriesOpt[0].symbolType];
                } else {
                    state.chartDataColor = object.seriesOpt.map((v, k) => {
                        if (k == 0) {
                            return "";
                        } else {
                            return v.lineStrokeColor;
                        }
                    });
                    state.symbolTypeList = object.seriesOpt.map((v, k) => {
                        if (k == 0) {
                            return "";
                        } else {
                            return v.symbolType;
                        }
                    });
                }
                // 添加雷达图指示器的最大值
                state.radarMaxIndicatorVal = object.CoordSysOpt.radarMaxIndicatorVal;
            }
            // funnel
            if (state.seriesShapeType == "funnel") {
                state.funnelGap = object.seriesOpt[0].gap;
                state.funnelMax = object.seriesOpt[0].max;
                state.funnelMaxLimit = object.seriesOpt[0].maxLimit;
                state.funnelMaxSize = object.seriesOpt[0].maxSize;
                state.funnelMin = object.seriesOpt[0].min;
                state.funnelMinLimit = object.seriesOpt[0].minLimit;
                state.funnelMinSize = object.seriesOpt[0].minSize;
                state.funnelSort = object.seriesOpt[0].sort;
                state.labelType = object.dataFormat.seriesLabelType;
                state.funnelPercent = object.seriesOpt[0].percentLabel;
                let arr = [];
                for (let i = 0, len = object.seriesOpt[0].sectorNames.length; i < len; i++) {
                    let obj = {
                        name: object.seriesOpt[0].sectorNames[i],
                        color: object.seriesOpt[0].sectorColors[i] == undefined ? "" : object.seriesOpt[0].sectorColors[i],
                    };
                    arr.push(obj);
                }
                state.pieList = arr;
            }

            /** more setting*/
            state.coordinateType = object.CoordSysOpt.type;
            if (object.CoordSysOpt.xAxis) {
                state.coordinateData[0] = {
                    name: object.CoordSysOpt.xAxis.name,
                    namePos: object.CoordSysOpt.xAxis.namePos,
                    max: object.CoordSysOpt.xAxis.max,
                    min: object.CoordSysOpt.xAxis.min,
                    splitNum: object.CoordSysOpt.xAxis.splitNum,
                    showSplitLine: object.CoordSysOpt.xAxis.showSplitLine,
                    GridxAxisLabelPosition: object.CoordSysOpt.xAxis.GridxAxisLabelPosition,
                    xAxisLabelPosition: object.CoordSysOpt.xAxis.xAxisLabelPosition,
                    showTick: object.CoordSysOpt.xAxis.showTick,
                    coordinateAxisShow: object.CoordSysOpt.xAxis.coordinateAxisShow,
                    axisLabelRotate: object.CoordSysOpt.xAxis.axisLabelRotate,
                    xLabelOrientationType: object.CoordSysOpt.xAxis.orientationType,
                    type: object.CoordSysOpt.xAxis.type,
                    minLimit: object.CoordSysOpt.xAxis.minLimit,
                    maxLimit: object.CoordSysOpt.xAxis.maxLimit,
                };
                state.xAxisAttr = state.coordinateData[0];
                state.coordinateColor = object.CoordSysOpt.xAxis.axisLineColor;
                state.scale_x = object.CoordSysOpt.xAxis.scale;
                if (object.isInit) {
                    state.coordinateName = state.coordinateData[state.coordinateRadio].name;
                    state.coordinatePosition = state.coordinateData[state.coordinateRadio].namePos;
                    state.coordinateMax = state.coordinateData[state.coordinateRadio].max;
                    state.coordinateMin = state.coordinateData[state.coordinateRadio].min;
                    state.coordinateSegment = state.coordinateData[state.coordinateRadio].splitNum;
                    state.coordinateShowSplit = state.coordinateData[state.coordinateRadio].showSplitLine;
                    state.coordinateShowScale = state.coordinateData[state.coordinateRadio].showTick;
                    state.coordinateAxisShow = state.coordinateData[state.coordinateRadio].coordinateAxisShow;
                    state.coordinateAxisLabelRotate = state.coordinateData[state.coordinateRadio].axisLabelRotate;
                    state.GridxAxisLabelPosition = state.coordinateData[state.coordinateRadio].GridxAxisLabelPosition;
                    state.xAxisLabelPosition = state.coordinateData[0].xAxisLabelPosition;
                    state.xLabelOrientationType = state.coordinateData[0].xLabelOrientationType;
                    state.minLimit = state.coordinateData[state.coordinateRadio].minLimit;
                    state.maxLimit = state.coordinateData[state.coordinateRadio].maxLimit;
                }
            }
            if (object.CoordSysOpt.yAxis) {
                state.coordinateData[1] = {
                    name: object.CoordSysOpt.yAxis.name,
                    namePos: object.CoordSysOpt.yAxis.namePos,
                    max: object.CoordSysOpt.yAxis.max,
                    min: object.CoordSysOpt.yAxis.min,
                    splitNum: object.CoordSysOpt.yAxis.splitNum,
                    showSplitLine: object.CoordSysOpt.yAxis.showSplitLine,
                    showTick: object.CoordSysOpt.yAxis.showTick,
                    yAxisLabelPosition: object.CoordSysOpt.yAxis.yAxisLabelPosition,
                    coordinateAxisShow: object.CoordSysOpt.yAxis.coordinateAxisShow,
                    axisLabelRotate: object.CoordSysOpt.yAxis.axisLabelRotate,
                    type: object.CoordSysOpt.yAxis.type,
                    minLimit: object.CoordSysOpt.yAxis.minLimit,
                    maxLimit: object.CoordSysOpt.yAxis.maxLimit,
                };
                state.yAxisAttr = state.coordinateData[1];
                state.scale_y = object.CoordSysOpt.yAxis.scale;
                state.coordinateColor = object.CoordSysOpt.yAxis.axisLineColor;
                if (object.isInit) {
                    state.coordinateName = state.coordinateData[state.coordinateRadio].name;
                    state.coordinatePosition = state.coordinateData[state.coordinateRadio].namePos;
                    state.coordinateMax = state.coordinateData[state.coordinateRadio].max;
                    state.coordinateMin = state.coordinateData[state.coordinateRadio].min;
                    state.coordinateSegment = state.coordinateData[state.coordinateRadio].splitNum;
                    state.coordinateShowSplit = state.coordinateData[state.coordinateRadio].showSplitLine;
                    state.yAxisLabelPosition = state.coordinateData[1].yAxisLabelPosition;
                    state.coordinateShowScale = state.coordinateData[state.coordinateRadio].showTick;
                    state.coordinateAxisShow = state.coordinateData[state.coordinateRadio].coordinateAxisShow;
                    state.coordinateAxisLabelRotate = state.coordinateData[state.coordinateRadio].axisLabelRotate;
                    state.minLimit = state.coordinateData[state.coordinateRadio].minLimit;
                    state.maxLimit = state.coordinateData[state.coordinateRadio].maxLimit;
                }
            }

            if (state.coordinateType == "radar") {
                state.coordinateSegment = object.CoordSysOpt.splitNum;
                state.coordinateShape = object.CoordSysOpt.shape;
                state.coordinateShowSplit = object.CoordSysOpt.showSplitLine;
                state.coordinateShowScale = object.CoordSysOpt.showAxisLine;
                // 修改雷达图指示器的最大值
                state.radarMaxIndicatorVal = object.CoordSysOpt.radarMaxIndicatorVal;
            }
            if (object.dataFormat) {
                let format = object.dataFormat;
                state.dataFormat = format.numFormat;
                state.dataFormatAccuracy = format.precision;
                state.dataFormatPercent = format.isPercent;
                state.dataFormatPreUnit = format.prefix;
                state.dataFormatSufUnit = format.suffix;
                state.axisPrefixSuffix = format.axisPrefixSuffix;
                state.valuePrefixSuffix = format.valuePrefixSuffix;
                state.hasPercent = format.hasPercent;
                state.isPercent = format.isPercent;
            }
        },
        updateEChart(state, object) {
            // 修改后重新获取值
            let data = window["_view"].getChartData();
            if (object.isInit && data) {
                data.isInit = true;
            }
            this.commit("initEChart", data);
        },
        updateEChartData(state, data) {
            if (data.type == "datasheet") {
                state.chartData = data.data;
            } else if (data.type == "color") {
                if (data.page == 1) {
                    state.showEChartData = true;
                }
                let object = window["_view"].getChartData();
                state.chartDataColo = [];
                /**bar */
                if (state.seriesShapeType == "bar") {
                    if (object.seriesOpt.length == 1) {
                        state.chartDataColor = ["", object.seriesOpt[0].barStrokeColor];
                    } else {
                        state.chartDataColor = object.seriesOpt.map((v, k) => {
                            if (k == 0) {
                                return "";
                            } else {
                                return v.barStrokeColor;
                            }
                        });
                    }
                }
                /**line */
                if (state.seriesShapeType == "line") {
                    if (object.seriesOpt.length == 1) {
                        state.chartDataColor = ["", object.seriesOpt[0].lineStrokeColor];
                    } else {
                        state.chartDataColor = object.seriesOpt.map((v, k) => {
                            if (k == 0) {
                                return "";
                            } else {
                                return v.lineStrokeColor;
                            }
                        });
                    }
                }
                /**pie */
                if (state.seriesShapeType == "pie") {
                    state.chartDataColor = object.seriesOpt[0].sectorColors;
                }
                /**radar */
                if (state.seriesShapeType == "radar") {
                    if (object.seriesOpt.length == 1) {
                        state.chartDataColor = ["", object.seriesOpt[0].lineStrokeColor];
                    } else {
                        state.chartDataColor = object.seriesOpt.map((v, k) => {
                            if (k == 0) {
                                return "";
                            } else {
                                return v.lineStrokeColor;
                            }
                        });
                    }
                }
            }
        },
        setEChart(state, type) {
            switch (type) {
                case "test": {
                    break;
                }
                case "currentSeries": {
                    break;
                }
                case "legend": {
                    window["_view"].processChartCMD("legendStatus", { data: state.legend });
                    break;
                }
                case "seriesGap": {
                    window["_view"].processChartCMD("barGap", { data: state.seriesGap / 100 });
                    break;
                }
                case "categoryGap": {
                    window["_view"].processChartCMD("categoryGap", { data: state.categoryGap / 100 });
                    break;
                }
                case "funnelGap": {
                    window["_view"].processChartCMD("funnelGap", { data: state.funnelGap });
                    break;
                }
                case "funnelMaxSize": {
                    window["_view"].processChartCMD("funnelMaxSize", { data: state.funnelMaxSize });
                    break;
                }
                case "funnelMinSize": {
                    window["_view"].processChartCMD("funnelMinSize", { data: state.funnelMinSize });
                    break;
                }
                case "seriesShapeType": {
                    (state.seriesShapeType == "line" && (window["_view"].processChartCMD("changeTypeToLine", { index: state.index }), true)) ||
                        window["_view"].processChartCMD("changeTypeToBar", { index: state.index });
                    break;
                }
                case "seriesLabelPosition": {
                    window["_view"].processChartCMD("labelPosition", { index: state.index, data: state.seriesLabelPosition });
                    break;
                }
                case "stackName": {
                    window["_view"].processChartCMD("stackName", { index: state.index, data: state.stackName ? "stack_0" : "" });
                    break;
                }
                case "chartData": {
                    window["_view"].processChartCMD("dataSheet", { data: state.chartData });
                    break;
                }
                case "barColor": {
                    window["_view"].processChartCMD("barStrokeColor", { index: state.index, data: state.barColor });
                    window["_view"].processChartCMD("barFilledColor", { index: state.index, data: state.barColor });
                    break;
                }
                case "lineColor": {
                    window["_view"].processChartCMD("lineStrokeColor", { index: state.index, data: state.lineColor });
                    break;
                }
                case "lineAreaFill": {
                    window["_view"].processChartCMD("AreaFilled", { index: state.index, data: state.lineAreaFill == "fill" });
                    break;
                }
                case "lineAreaFilledColor": {
                    window["_view"].processChartCMD("AreaFilledColor", { index: state.index, data: state.lineAreaFilledColor });
                    break;
                }
                case "lineStepType": {
                    window["_view"].processChartCMD("stepType", { index: state.index, data: state.lineStepType });
                    break;
                }
                case "symbolType": {
                    window["_view"].processChartCMD("symbolType", { index: state.index, data: state.symbolTypeList[state.index] });
                    break;
                }
                case "symbolSize": {
                    window["_view"].processChartCMD("symbolSize", { index: state.index, data: state.symbolSize });
                    break;
                }
                case "symbolColor": {
                    window["_view"].processChartCMD("symbolColor", { index: state.index, data: state.symbolColor });
                    break;
                }
                case "setBubbleMode": {
                    window["_view"].processChartCMD("setBubbleMode", { data: state.setBubbleMode != "scatter" });
                    break;
                }
                case "BubleRange": {
                    let obj = {
                        BubbleMaxSize: state.BubbleMaxSize,
                        BubbleMinSize: state.BubbleMinSize,
                        maxValue: state.maxValue,
                        minValue: state.minValue,
                    };
                    window["_view"].processChartCMD("bubbleRange", { data: obj });
                    break;
                }
                case "insideRadiusRatio": {
                    window["_view"].processChartCMD("insideRadiusRatio", { data: state.insideRadiusRatio / 100 });
                    break;
                }
                case "sectorColors": {
                    let arr = [];
                    for (let i = 0; i < state.pieList.length; i++) {
                        arr.push(state.pieList[i].color);
                    }
                    state.chartDataColor = null;
                    state.chartDataColor = arr;

                    window["_view"].processChartCMD("sectorColors", { data: arr });
                    break;
                }
                case "offset": {
                    let arr = [];
                    for (let i = 0; i < state.pieList.length; i++) {
                        arr.push(state.pieList[i].offset);
                    }
                    window["_view"].processChartCMD("offset", { data: arr });
                    break;
                }
                case "startAngle": {
                    window["_view"].processChartCMD("startAngle", { data: state.pieRotate });
                    break;
                }
                case "gaugeRange": {
                    let obj = {
                        min: state.gaugeRangeMinsize,
                        max: state.gaugeRangeMaxsize,
                    };
                    window["_view"].processChartCMD("gaugeRange", { data: obj });
                    break;
                }
                case "gaugeSectorAdd": {
                    let arr = state.gaugeRangeArr[state.gaugeRangeArr.length - 2].slice(0);
                    state.gaugeRangeArr.splice(state.gaugeRangeArr.length - 2, 0, arr);
                    window["_view"].processChartCMD("gaugeSector", { data: state.gaugeRangeArr });
                    break;
                }
                case "gaugeSectorDel": {
                    if (state.gaugeRangeArr.length == 2) {
                        return;
                    }
                    state.gaugeRangeArr.splice(state.gaugeRangeArr.length - 2, 1);
                    window["_view"].processChartCMD("gaugeSector", { data: state.gaugeRangeArr });
                    break;
                }
                case "gaugeSector": {
                    window["_view"].processChartCMD("gaugeSector", { data: state.gaugeRangeArr });
                    break;
                }
                case "changeCoordinateType": {
                    let index = state.coordinateRadio;
                    state.coordinateName = state.coordinateData[index].name;
                    state.coordinatePosition = state.coordinateData[index].namePos;
                    state.coordinateMax = state.coordinateData[index].max;
                    state.coordinateMin = state.coordinateData[index].min;
                    state.coordinateSegment = state.coordinateData[index].splitNum;
                    state.coordinateShowSplit = state.coordinateData[index].showSplitLine;
                    state.coordinateShowScale = state.coordinateData[index].showTick;
                    state.coordinateAxisShow = state.coordinateData[index].coordinateAxisShow;
                    state.coordinateAxisLabelRotate = state.coordinateData[index].axisLabelRotate;
                    state.minLimit = state.coordinateData[index].minLimit;
                    state.maxLimit = state.coordinateData[index].maxLimit;
                    if (index == 0) {
                        state.GridxAxisLabelPosition = state.coordinateData[index].GridxAxisLabelPosition;
                        state.xAxisLabelPosition = state.coordinateData[index].xAxisLabelPosition;
                        state.xLabelOrientationType = state.coordinateData[index].xLabelOrientationType;
                        state.xAxisAttr = state.coordinateData[0];
                    } else {
                        state.yAxisLabelPosition = state.coordinateData[index].yAxisLabelPosition;
                        state.yAxisAttr = state.coordinateData[1];
                    }
                    break;
                }
                case "percentLabel": {
                    window["_view"].processChartCMD("percentLabel", { data: state.percentLabel });
                    break;
                }
                case "roseType": {
                    window["_view"].processChartCMD("roseType", { data: state.roseType });
                    break;
                }
                case "smoothLine": {
                    window["_view"].processChartCMD("smooth", { data: state.smoothLine, index: 0 });
                    break;
                }
                case "mapColorDataAdd": {
                    let arr = state.mapColorData[0].slice(0);
                    state.mapColorData.unshift(arr);
                    let upData = [];
                    let mapData = state.mapColorData;
                    for (let i = 0; i < mapData.length; i++) {
                        let obj = {
                            min: i == mapData.length - 1 ? state.visualMapMin : mapData[i + 1][0],
                            max: mapData[i][0],
                            color: mapData[i][1],
                        };
                        upData.push(obj);
                    }
                    window["_view"].processChartCMD("visualMapPieces", { data: upData });
                    break;
                }
                case "mapColorDataDel": {
                    if (state.mapColorData.length == 2) {
                        return;
                    }
                    state.mapColorData.splice(1, 1);
                    let upData = [];
                    let mapData = state.mapColorData;
                    for (let i = 0; i < mapData.length; i++) {
                        let obj = {
                            min: i == mapData.length - 1 ? state.visualMapMin : mapData[i + 1][0],
                            max: mapData[i][0],
                            color: mapData[i][1],
                        };
                        upData.push(obj);
                    }
                    window["_view"].processChartCMD("visualMapPieces", { data: upData });
                    break;
                }
                case "mapColorData": {
                    let upData = [];
                    let mapData = state.mapColorData;
                    for (let i = 0; i < mapData.length; i++) {
                        let obj = {
                            min: i == mapData.length - 1 ? state.visualMapMin : mapData[i + 1][0],
                            max: mapData[i][0],
                            color: mapData[i][1],
                        };
                        upData.push(obj);
                    }
                    window["_view"].processChartCMD("visualMapPieces", { data: upData });
                    break;
                }
            }
            this.commit("updateEChart", { isInit: false });
        },
    },
};
